"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Footer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("@paprika/stylers/lib/helpers");

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "Footerstyles__Footer",
  componentId: "sc-7mvb2i-0"
})(["align-items:center;border-top:1px solid ", ";box-sizing:border-box;display:flex;height:", ";justify-content:flex-start;padding:8px;& > div{width:calc(50% - 8px);[role=\"button\"]{margin-right:20px;}}& > div + div{text-align:right;}"], _tokens["default"].color.blackLighten60, (0, _helpers.spacer)(6));

exports.Footer = Footer;
//# sourceMappingURL=Footer.styles.js.map